export default "__VITE_ASSET__ac9d504f__"